import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import { Chart } from "./components/Chart/Chart"
import styles from "./index.module.css"

export const Stock: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className="container grid grid--col-12">
        <div className={styles.Head}>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("investors-and-shareholders.Stock.Title")} />
          </Heading>
          <Link href="/investors-and-shareholders/stock" view="arrow">
            <Raw html={t("investors-and-shareholders.Stock.Link")} />
          </Link>
        </div>

        <div className={styles.Description}>
          <Raw html={t("investors-and-shareholders.Stock.Text")} />
        </div>
      </div>

      <div className="container">
        <Wrapper className={styles.Chart}>
          <Chart />
        </Wrapper>
      </div>
    </>
  )
}
